<template>
  <div
    ref="messagesContainer"
    class="tw-flex tw-flex-col tw-gap-2 tw-my-4 tw-pr-4 tw-border tw-border-gray-300 tw-overflow-y-auto tw-h-[500px] tw-max-h-[600vh]"
  >
    <div v-for="message in messages" :key="message.id">
      <Message
        :is-authored="message.isAuthored"
        :avatar-path="props.userAvatarPath"
        :is-pending="message.isPending"
        :content="message.content"
        :message-uuid="message.uuid"
        :rating="message.rating"
        :timestamp="message.timestamp"
        @update:rating="(rating) => $emit('update:rating', message.uuid, rating)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { nextTick, onMounted, ref, watch } from 'vue'
import Message from '@/components/LLM/Message.vue'

interface Props {
  messages: {
    id: string
    uuid?: string
    isAuthored: boolean
    content: string
    isPending: boolean
    rating?: string | null
    timestamp?: string
  }[]
  userAvatarPath: string
}

const props = defineProps<Props>()
const emit = defineEmits(['update:rating'])

const messagesContainer = ref<HTMLElement | null>(null)

const scrollToBottom = () => {
  if (messagesContainer.value) {
    messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
  }
}

onMounted(() => {
  scrollToBottom()
})

watch(
  () => props.messages,
  async () => {
    await nextTick()
    scrollToBottom()
  },
  { deep: true },
)
</script>
